import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function RainstormIncident(props) {
  const blue = getColorValue('illustrationAccent');
  const purple = getColorValue('illustrationPurple');
  const gray = getColorValue('illustrationRainstormGray');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <g fill={blue}>
        <path d="m76.6696 200.43c12.04-.09 20.99-11.27 18.33-23.01-2.75-12.17-8.14-27.19-18.67-40-9.28 12.71-14.8 27.21-18.05 39.11-3.31 12.1 5.85 24 18.39 23.91z" />
        <path d="m176.75 238.59c12.04-.09 20.99-11.27 18.33-23.01-2.75-12.17-8.14-27.19-18.67-40-9.28 12.71-14.8 27.21-18.05 39.11-3.31 12.1 5.85 24 18.39 23.91z" />
        <path d="m186.75 160.92c12.04-.09 20.99-11.27 18.33-23.01s-8.14-27.19-18.67-39.9998c-9.28 12.7098-14.8 27.2098-18.05 39.1098-3.31 12.1 5.85 24 18.39 23.91z" />
      </g>
      <path
        d="m200.56 76.83c-.74 0-1.48.01-2.21.04-11.24-28.81-34.84-40.87-70.03-40.87-50.4398 0-78.1198 25.24-78.1198 90.01h202.5798c-5.71-32.21-25-49.18-52.23-49.18z"
        fill={purple}
      />
      <path
        d="m55.4 126.09h50.92c-4.56-25.73-19.97-39.2697-41.71-39.2697-20.24 0-33.98 10.29-42.11 39.2697z"
        fill={purple}
      />
      <path
        d="m171.84 126h29.87c-3.19-9.3-8.01-19.22-15.3-28.0898-6.56 8.9898-11.23 18.8698-14.56 28.0898z"
        fill={illustrationColors.staticDarkBlue}
      />
      <path
        d="m100.586 218.768c-3.03 2.65-2.32 3.51.86 1.04 4.5-3.5 9.18-7.24 15.12-12.12 6.7-5.59 8.23-7.15 12.81-10.88 3.85-3.18 9.08-7.38 13.74-11.11 5.23-4.18 9.81-7.83 11.58-9.26l.36-.29c-.95-.44-1.89-.88-2.84-1.33-1.99-.91-7.35-3.36-14.1-6.44-3.31-1.53-6.95-3.21-10.69-4.94-3.41-1.59-6.91-3.23-10.27-4.8l-.07-.03 15.56-12.5c6.83-5.49 11.86-9.67 16.74-13.86 2.68-2.3 2.07-3.06-.75-.94-5.14 3.86-10.32 7.86-17.16 13.34-1.33 1.06-3.42 2.65-6.15 4.76-1.36 1.06-2.89 2.24-4.57 3.54-1.85 1.46-3.87 3.05-6.06 4.77-.58.46-1.16.93-1.74 1.39 1.14.53 2.28 1.05 3.42 1.57.57.25 1.15.51 1.72.76 12.81 5.56 29.19 13.3 29.19 13.3l4.04 1.88-24.17 19.91c-6.63 5.47-9.82 8.1-11.78 9.72-5.93 4.9-10.5 8.78-14.79 12.53z"
        fill={gray}
      />
    </svg>
  );
}

export default RainstormIncident;
